import React, { Component } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

import { SECTION_LINKS } from 'app/constants/feed'
import { getFeedLeaderBoardSection } from 'store/entities/feed/selectors'
import { setLeaderBoardSection } from 'store/entities/feed/actions'

const mapStateToProps = state => ({
  section: getFeedLeaderBoardSection(state),
})

const mapDispatchToProps = {
  setSection: setLeaderBoardSection,
}

// TODO: @serginyo90 need refactor this component
class LeaderBoardDropDown extends Component {
  state = {
    isOpen: false,
  }

  constructor(...opts) {
    super(...opts)
    this.onBodyClick = this.onBodyClick.bind(this)
  }

  onBodyClick(event) {
    if (!event.target.closest('.leader-board-dropdown')) {
      this.setState({
        isOpen: false,
      })
    }
  }

  componentDidMount() {
    document.body.addEventListener('click', this.onBodyClick)
  }

  componentWillUnmount() {
    document.body.removeEventListener('click', this.onBodyClick)
  }

  render() {
    const activeLinkTitle = SECTION_LINKS[SECTION_LINKS.findIndex(link => link.section === this.props.section)].title
    const { t } = this.props
    return (
      <div
        className={classNames({
          'leader-board-dropdown': true,
          'leader-board-dropdown--open': this.state.isOpen,
        })}
        onClick={() => this.setState({ isOpen: !this.state.isOpen })}
      >
        <div className="leader-board-dropdown__title">{t(activeLinkTitle)}</div>
        <div className="leader-board-dropdown__arrow" />
        <div className="leader-board-dropdown__content">
          {SECTION_LINKS.map(link => (
            <div
              key={link.section}
              className="leader-board-dropdown__link"
              onClick={() => this.props.setSection(link.section)}
            >
              {t(link.title)}
            </div>
          ))}
        </div>
      </div>
    )
  }
}

LeaderBoardDropDown.displayName = 'LeaderBoardDropDown'

const LeaderBoardDropDownContainer = connect(mapStateToProps, mapDispatchToProps)(LeaderBoardDropDown)

LeaderBoardDropDownContainer.displayName = 'LeaderBoardDropDownContainer'

export default withTranslation()(LeaderBoardDropDownContainer)
